import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '../lib/utils';

export type SpinnerSize = 'sm' | 'md' | 'lg';
export type SpinnerVariant = 'inline' | 'overlay' | 'fullpage';

interface SpinnerProps {
  size?: SpinnerSize;
  variant?: SpinnerVariant;
  label?: string;
  className?: string;
}

const sizeClasses: Record<SpinnerSize, string> = {
  sm: 'w-4 h-4',
  md: 'w-6 h-6',
  lg: 'w-10 h-10',
};

export default function Spinner({ size = 'md', variant = 'inline', label, className }: SpinnerProps) {
  const icon = (
    <Loader2 className={cn('animate-spin text-primary', sizeClasses[size], className)} />
  );

  if (variant === 'inline') {
    return label ? (
      <span className="inline-flex items-center gap-2">
        {icon}
        <span className="text-sm text-muted-foreground font-inter">{label}</span>
      </span>
    ) : icon;
  }

  const wrapperClasses = variant === 'fullpage'
    ? 'fixed inset-0 flex flex-col items-center justify-center gap-3 bg-background/60 z-50'
    : 'absolute inset-0 flex flex-col items-center justify-center gap-3 bg-surface/60 z-10';

  return (
    <div className={wrapperClasses}>
      {icon}
      {label && <span className="text-sm text-muted-foreground font-inter">{label}</span>}
    </div>
  );
}
